import React from "react";
import { NavLink } from "react-router-dom";
import { IconButton, Stack, Typography } from "@mui/material";

//@ts-ignore
import { ReactComponent as Logo } from "../../assets/images/logo_v2.svg";
import "./index.scss";
import { DarkMode, LightMode } from "@mui/icons-material";
import { useTheme } from "../../hooks";

export default function NotepadHeader(props: any) {
    const { notepadId, warning }: { notepadId: string; warning: boolean } = { ...props };
    const { mode, setMode } = useTheme();

    const changeTheme = () => {
        setMode((current: any) => (current === "dark" ? "light" : "dark"));
    };
    return (
        <header>
            <Stack direction="row" alignItems={"center"} justifyContent={"space-between"} className="header-wrapper">
                <nav>
                    <NavLink to="/notedrop" className="header-logo-link">
                        <Logo
                            style={{
                                width: 32,
                                height: 32,
                                filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.1))",
                            }}
                        />
                        <Stack spacing={0}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontFamily: "var(--fq-font-family)",
                                    fontWeight: 800,
                                    fontSize: "1.05rem",
                                    letterSpacing: "-0.02em",
                                    color: "var(--fq-primary-text-color)",
                                    lineHeight: 1.1,
                                }}
                            >
                                NoteDrop
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: "0.65rem",
                                    fontWeight: 500,
                                    color: "var(--fq-secondary-text-color)",
                                    letterSpacing: "0.05em",
                                    textTransform: "uppercase",
                                    opacity: 0.8,
                                }}
                            >
                                nithinpb.com product
                            </Typography>
                        </Stack>
                    </NavLink>
                    {notepadId && (
                        <div
                            className={`notepad-id-badge sketchy-border ${warning ? "has-warning blink_me" : "no-warning"}`}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: 13,
                                    fontFamily: "var(--fq-font-hand-body)",
                                    color: "var(--fq-primary-text-color)",
                                }}
                            >
                                {notepadId}
                            </Typography>
                        </div>
                    )}
                </nav>
                <IconButton onClick={changeTheme} className="editor-theme-toggle" size={"small"}>
                    {mode === "dark" ? (
                        <DarkMode fontSize={"small"} sx={{ color: "var(--fq-primary-text-color)" }} />
                    ) : (
                        <LightMode fontSize={"small"} sx={{ color: "var(--fq-primary-text-color)" }} />
                    )}
                </IconButton>
            </Stack>
        </header>
    );
}
